// 离职员工列表
<template>
  <div class="threeLevelMain">
    <div class="module_title">
      <h3 class="h3_title">离职员工信息列表</h3>
      <div class="btnbox_title">
        <input
          type="file"
          @change="importClick"
          ref="uploader"
          class="upload-btn"
        />
        <el-button size="mini">导入信息</el-button>
        <el-button type="text" @click="exportHandle">导出</el-button>
      </div>
    </div>
    <div class="queryBox" style="margin-top: 10px;">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">生日筛选：</span>
          <el-select
            v-model="queryForm.birthday"
            size="mini"
            class="ip_scan_range"
          >
            <el-option
              v-for="bir in options.birthdayOptions"
              :key="bir.value"
              :label="bir.label"
              :value="bir.value"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">职务：</span>
          <el-select v-model="queryForm.post" size="mini" class="ip_scan_range">
            <el-option
              v-for="bir in postOptions"
              :key="bir.value"
              :label="bir.label"
              :value="bir.value"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">上级：</span>
          <el-select
            v-model="queryForm.leader_id"
            size="mini"
            class="ip_scan_sort"
            clearable
          >
            <el-option-group
              v-for="group in leaderOptions"
              :key="group.value"
              :label="group.label"
            >
              <el-option
                v-for="(item, index) in group.options"
                :label="item.label"
                :value="item.value"
                :key="index"
              >
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.postName
                }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">部门：</span>
          <el-select
            v-model="queryForm.department"
            size="mini"
            class="ip_scan_sort"
          >
            <el-option
              v-for="de in options.department"
              :key="de.value"
              :label="de.label"
              :value="de.value"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">入职月份：</span>
          <el-select v-model="queryForm.month" size="mini" class="ip_scan_sort">
            <el-option
              v-for="de in options.birthdayOptions"
              :key="de.value"
              :label="de.label"
              :value="de.value"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">入职时间：</span>
          <el-date-picker
            :unlink-panels="true"
            v-model="queryForm.add_time"
            size="mini"
            type="daterange"
            class="date_range"
            range-separator="-"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan">姓名：</span>
          <el-input
            v-model="queryForm.name"
            size="mini"
            class="ip_scan_range"
          ></el-input>
        </div>

        <!-- 查询按钮 -->
        <div class="btn_box">
          <el-button
            size="mini"
            type="primary"
            @click="
              updateDataTag = !updateDataTag;
              currentPage = 1;
            "
            >查询</el-button
          >
          <el-button size="mini" @click="resetQuery">重置</el-button>
        </div>
      </div>
    </div>
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
    >
      <el-table-column slot="gender" align="center" label="性别" width="50">
        <template slot-scope="scope">
          <div>{{ scope.row.gender == 1 ? "男" : "女" }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="department" align="center" label="部门">
        <template slot-scope="scope">
          <div>
            {{
              options.department.filter(
                (item) => item.value == scope.row.department
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column slot="post" align="center" label="职务">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.post != ""
                ? postOptions.filter((item) => item.value == scope.row.post)[0]
                    .label
                : "-"
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 修改信息 -->
      <el-table-column
        slot="requireInfo"
        align="center"
        label="修改"
        width="80"
      >
        <template slot-scope="scope">
          <el-button
            class="fontColor_theme"
            type="text"
            @click="openDialog('revise', scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </tablePageComp>

    <div class="dialogSY">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="900px"
        :before-close="handleClose"
        center
      >
        <el-form
          :model="addInfoForm"
          :rules="rules"
          status-icon
          ref="addInfoForm"
          label-width="100px"
          label-position="top"
          :inline="true"
          class="form-main"
          size="small"
        >
          <el-form-item
            label="姓名"
            prop="name"
            class="formItems"
            :disabled="dialogTitle == '修改信息' ? true : false"
          >
            <el-input v-model="addInfoForm.name"></el-input>
          </el-form-item>

          <el-form-item label="电话" prop="phone" class="formItems">
            <el-input v-model.number="addInfoForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="生日" prop="birthday" class="formItems">
            <el-date-picker
              v-model="addInfoForm.birthday"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="部门" prop="department" class="formItems">
            <el-select v-model="addInfoForm.department" class="f-select">
              <el-option
                v-for="bir in options.department"
                :key="bir.value"
                :label="bir.label"
                :value="bir.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务" prop="post" class="formItems">
            <el-select v-model="addInfoForm.post" class="f-select">
              <el-option
                v-for="bir in postOptions"
                :key="bir.value"
                :label="bir.label"
                :value="bir.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上级" prop="leader_id" class="formItems">
            <el-select v-model="addInfoForm.leader_id" class="f-select">
              <el-option-group
                v-for="group in leaderOptions"
                :key="group.value"
                :label="group.label"
              >
                <el-option
                  v-for="(item, index) in group.options"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.postName
                  }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="gender" class="formItems">
            <el-select v-model="addInfoForm.gender" class="f-select">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" prop="mail" class="formItems">
            <el-input v-model="addInfoForm.mail"></el-input>
          </el-form-item>
          <el-form-item label="入职时间" prop="add_time" class="formItems">
            <el-date-picker
              v-model="addInfoForm.add_time"
              type="date"
              class="f-select"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="离职时间"
            prop="departure_time"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.departure_time"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="来源" prop="source" class="formItems">
            <el-input v-model="addInfoForm.source"></el-input>
          </el-form-item>
          <el-form-item label="转正时间" prop="regula" class="formItems">
            <el-date-picker
              v-model="addInfoForm.regula"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工龄" prop="working_years" class="formItems">
            <el-input v-model="addInfoForm.working_years"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="id_number" class="formItems">
            <el-input v-model="addInfoForm.id_number"></el-input>
          </el-form-item>
          <el-form-item label="民族" prop="nation" class="formItems">
            <el-input v-model="addInfoForm.nation"></el-input>
          </el-form-item>
          <el-form-item label="婚否" prop="marriage" class="formItems">
            <el-input v-model="addInfoForm.marriage"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="education" class="formItems">
            <el-input v-model="addInfoForm.education"></el-input>
          </el-form-item>
          <el-form-item label="毕业院校" prop="school" class="formItems">
            <el-input v-model="addInfoForm.school"></el-input>
          </el-form-item>
          <el-form-item
            label="毕业时间"
            prop="graduation_time"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.graduation_time"
              align="right"
              type="month"
              value-format="yyyy-MM"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="专业" prop="major" class="formItems">
            <el-input v-model="addInfoForm.major"></el-input>
          </el-form-item>
          <el-form-item label="现住址" prop="current_address" class="formItems">
            <el-input
              type="textarea"
              :rows="1"
              v-model="addInfoForm.current_address"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="户籍地址"
            prop="permanent_address"
            class="formItems"
          >
            <el-input
              type="textarea"
              :rows="1"
              v-model="addInfoForm.permanent_address"
            ></el-input>
          </el-form-item>
          <el-form-item label="户口性质" prop="nature" class="formItems">
            <el-input v-model="addInfoForm.nature"></el-input>
          </el-form-item>
          <el-form-item
            label="合同签订"
            prop="contract_signing"
            class="formItems"
          >
            <!-- <el-input v-model="addInfoForm.contract_signing"></el-input> -->
            <el-select v-model="addInfoForm.contract_signing" class="f-select">
              <el-option
                v-for="(i, ind) in options.contractSignOptions"
                :key="ind"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="合同类别"
            prop="contract_category"
            class="formItems"
          >
            <!-- <el-input v-model="addInfoForm.contract_category"></el-input> -->
            <el-select
              v-model="addInfoForm.contract_category"
              class="f-select"
              @change="categoryChange"
            >
              <el-option
                v-for="(i, ind) in options.contractCateOptions"
                :key="ind"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="合同签订日期"
            prop="contract_signing_date"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.contract_signing_date"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
              @change="contractDateChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="合同到期日期"
            prop="contract_expiration_date"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.contract_expiration_date"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="转正情况"
            prop="employment_confirmation"
            class="formItems"
          >
            <!-- <el-input v-model="addInfoForm.employment_confirmation"></el-input> -->
            <el-select
              v-model="addInfoForm.employment_confirmation"
              class="f-select"
            >
              <el-option
                v-for="(i, ind) in options.employmentOptions"
                :key="ind"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="社保缴纳"
            prop="social_security_payment"
            class="formItems"
          >
            <el-input v-model="addInfoForm.social_security_payment"></el-input>
          </el-form-item>
          <el-form-item
            label="社保缴纳单位"
            prop="social_security_payer"
            class="formItems"
          >
            <el-input v-model="addInfoForm.social_security_payer"></el-input>
          </el-form-item>
          <el-form-item
            label="社保缴纳时间"
            prop="social_security_payment_time"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.social_security_payment_time"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="公积金缴纳时间"
            prop="provident_fund_time"
            class="formItems"
          >
            <el-date-picker
              v-model="addInfoForm.provident_fund_time"
              align="right"
              type="date"
              value-format="yyyy-MM-dd"
              class="f-select"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="银行卡号" prop="bank_card" class="formItems">
            <el-input v-model="addInfoForm.bank_card"></el-input>
          </el-form-item>
          <el-form-item
            label="紧急联系人"
            prop="emergency_contact"
            class="formItems"
          >
            <el-input v-model="addInfoForm.emergency_contact"></el-input>
          </el-form-item>
          <el-form-item
            label="紧急联系电话"
            prop="emergency_contact_number"
            class="formItems"
          >
            <el-input v-model="addInfoForm.emergency_contact_number"></el-input>
          </el-form-item>
          <el-form-item class="formItems"> </el-form-item>
          <el-form-item class="formItems"> </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="actionHandle('addInfoForm')"
            size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import utils from "@/libs/utils";
import api from "@/api";

export default {
  data() {
    let jur = utils.sessionGetStore("jurisdiction");

    return {
      department: utils.sessionGetStore("department"),
      jurisdiction: jur, // 权限
      dialogVisible: false,
      // 内容相关
      dataList: [], //表格数据
      columnsList: [
        {
          label: "修改信息",
          slotName: "requireInfo",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "性别",
          slotName: "gender",
        },
        {
          label: "生日",
          prop: "birthday",
          width: 100,
        },
        {
          label: "电话",
          prop: "phone",
          width: 100,
        },
        {
          label: "邮箱",
          prop: "mail",
          width: 180,
        },
        {
          label: "部门",
          slotName: "department",
        },
        {
          label: "职务",
          slotName: "post",
        },
        {
          label: "上级",
          prop: "leader_name",
          width: 100,
        },
        {
          label: "入职时间",
          prop: "add_time",
          width: 100,
        },
        {
          label: "离职时间",
          prop: "departure_time",
          width: 100,
        },
        {
          label: "来源",
          prop: "source",
          width: 100,
        },
        {
          label: "转正时间",
          prop: "regula",
          width: 100,
        },
        {
          label: "工龄",
          prop: "working_years",
          width: 100,
        },
        {
          label: "身份证号",
          prop: "id_number",
          width: 150,
        },
        {
          label: "民族",
          prop: "nation",
        },
        {
          label: "婚否",
          prop: "marriage",
        },
        {
          label: "学历",
          prop: "education",
        },
        {
          label: "毕业院校",
          prop: "school",
          width: 100,
        },
        {
          label: "毕业时间",
          prop: "graduation_time",
          width: 100,
        },
        {
          label: "专业",
          prop: "major",
          width: 100,
        },
        {
          label: "现住址",
          prop: "current_address",
          width: 120,
        },
        {
          label: "户籍地址",
          prop: "permanent_address",
          width: 120,
        },
        {
          label: "户口性质",
          prop: "nature",
        },
        {
          label: "合同签订",
          prop: "contract_signing",
          width: 100,
        },
        {
          label: "合同类别",
          prop: "contract_category",
        },
        {
          label: "合同签订日期",
          prop: "contract_signing_date",
          width: 100,
        },
        {
          label: "合同到期日期",
          prop: "contract_expiration_date",
          width: 100,
        },
        {
          label: "转正情况",
          prop: "employment_confirmation",
        },
        {
          label: "社保缴纳",
          prop: "social_security_payment",
          width: 100,
        },
        {
          label: "社保缴纳单位",
          prop: "social_security_payer",
          width: 100,
        },
        {
          label: "社保缴纳时间",
          prop: "social_security_payment_time",
          width: 100,
        },
        {
          label: "公积金缴纳时间",
          prop: "provident_fund_time",
          width: 105,
        },
        {
          label: "银行卡号",
          prop: "bank_card",
          width: 150,
        },
        {
          label: "紧急联系人",
          prop: "emergency_contact",
          width: 100,
        },
        {
          label: "紧急联系电话",
          prop: "emergency_contact_number",
          width: 100,
        },
      ], // 列
      updateDataTag: false, // 主动更新标记
      resetPageNum: true, // 是否重置页面
      totalCount: 0, // 数据总条数
      addInfoForm: {
        name: "",
        gender: "",
        birthday: "",
        phone: "",
        mail: "",
        department: "", // 部门
        post: "", // 职务
        leader_id: "", // 上级
        add_time: "", // 入职时间
        departure_time: "", // 离职时间
        source: "", // 来源
        regula: "", // 转正时间
        working_years: "", // 工龄
        id_number: "", // 身份证号
        nation: "", // 民族
        marriage: "", // 婚否
        education: "", // 学历
        school: "", // 毕业院校
        graduation_time: "", // 毕业时间
        major: "", // 专业
        current_address: "", // 现住址
        permanent_address: "", // 户籍地址
        nature: "", // 户口性质
        contract_signing: "", // 合同签订
        contract_category: "", // 合同类别
        contract_signing_date: "", // 合同签订日期
        contract_expiration_date: "", // 合同到期日期
        employment_confirmation: "", // 转正情况
        social_security_payment: "", // 社保缴纳
        social_security_payer: "", // 社保缴纳单位
        social_security_payment_time: "", // 社保缴纳时间
        provident_fund_time: "", // 公积金缴纳时间
        bank_card: "", // 银行卡号
        emergency_contact: "", // 紧急联系人
        emergency_contact_number: "", // 紧急联系电话
      }, // 新建人员信息表单
      rules: {
        name: [{ required: true, message: "请输入名字", trigger: "blur" }],
        phone: [
          { required: true, trigger: "blur", message: "请输入电话" },
          { type: "number", message: "请输入数字" },
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        post: [{ required: true, message: "请选择职务", trigger: "change" }],
        birthday: [
          { required: true, message: "生日为必填项", trigger: "change" },
        ],
        leader_id: [
          { required: true, message: "请选择上级", trigger: "change" },
        ],
        departure_time: [
          { required: true, message: "离职时间为空", trigger: "change" },
        ],
        mail: [{ required: true, message: "请填入邮箱", trigger: "change" }],
      },
      queryForm: {
        birthday: "",
        add_time: "", // 入职时间
        month: "",
        post: "",
        leader_id: "", // 上级
        name: "",
        department: "",
      },
      dialogTitle: "标题",
    };
  },
  computed: {
    postOptions() {
      return this.$store.state.commonOptions.postOptions;
    },
    options() {
      return this.$store.state.commonOptions;
    },
    // 上级选项
    leaderOptions() {
      return this.$store.state.leaderOptions;
    },
  },
  created() {},
  methods: {
    // 合同类别修改
    categoryChange(e) {
      // console.log(e)
      let date = this.addInfoForm.contract_signing_date;
      if (date) {
        if (e == "实习协议") {
          let rec = date.split("-");
          if (Number(rec[1]) >= 7) {
            // 月份大于7  则到期日为来年的6.30
            this.addInfoForm.contract_expiration_date =
              parseInt(rec[0]) + 1 + "-6-30";
          } else {
            this.addInfoForm.contract_expiration_date = rec[0] + "-6-30";
          }
        } else {
          this.addInfoForm.contract_expiration_date = utils.contractDate(
            date,
            3
          );
        }
      }
    },
    // 合同签订日期修改
    contractDateChange(e) {
      if (e) {
        // 如果合同类别为实习协议，合同到期日默认为6月30日
        if (this.addInfoForm.contract_category == "实习协议") {
          let rec = e.split("-");
          if (Number(rec[1]) >= 7) {
            // 月份大于7  则到期日为来年的6.30
            this.addInfoForm.contract_expiration_date =
              parseInt(rec[0]) + 1 + "-6-30";
          } else {
            this.addInfoForm.contract_expiration_date = rec[0] + "-6-30";
          }
        } else {
          // 合同有效期为3年
          this.addInfoForm.contract_expiration_date = utils.contractDate(e, 3);
        }
      } else {
        this.addInfoForm.contract_expiration_date = "";
      }

      // console.log(e)
    },
    // 导出信息
    exportHandle() {
      let paramObj = {
        is_departure: 1, // 0 在职 1 离职
      };
      const loading = this.$loading({
        lock: true,
        text: "正在导出信息...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api
        .exportPersonInfo(paramObj)
        .then((res) => {
          loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            window.location.href = res.data.data.url;
          }
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          utils.notificationInfo("错误提示", "导出失败", "error");
        });
    },
    setRPN(e) {
      this.resetPageNum = e;
    },
    // 导入信息
    importClick(e) {
      let files = e.target.files[0];
      let formData = new FormData();
      formData.append("file", files);
      formData.append("is_departure", 1); // 0 在职 1 离职
      this.$refs.uploader.value = null;

      const loading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api
        .importPersonInfo(formData)
        .then((res) => {
          loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            utils.notificationInfo("提示", `${res.data.msg}`, "success");
            this.updateDataTag = !this.updateDataTag;
          } else {
            utils.notificationInfo("提示", `${res.data.msg}`, "warning");
          }
        })
        .catch((error) => {
          loading.close();
          utils.notificationInfo("错误提示", "导入失败", "error");
          console.log(error);
        });
    },
    // 操作-----修改/添加
    // 打开dialog
    openDialog(type, data) {
      this.dialogVisible = true;

      if (type == "add") {
        // 点击新建按钮
        this.dialogTitle = "新建信息";
        this.addInfoForm = {
          name: "",
          gender: "",
          birthday: "",
          phone: "",
          mail: "",
          department: "",
          post: "",
          leader_id: "",
        };
      } else if (type == "revise") {
        // 修改
        this.dialogTitle = "修改信息";
        Object.keys(this.addInfoForm).forEach((item) => {
          if (data[item] != "") {
            this.addInfoForm[item] = data[item];
          }
        });
        this.addInfoForm.phone = Number(data.phone);
        this.addInfoForm.leader_id = data.leader_id;
        this.addInfoForm.id = data.id;
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 确认操作按钮
    actionHandle(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //add
          if (this.dialogTitle == "新建信息") {
            // console.log(this.addInfoForm)
            api
              .addPersonInfo(this.addInfoForm)
              .then((res) => {
                // console.log(res)
                this.dialogVisible = false;
                if (res.data.code == 0) {
                  utils.notificationInfo("提示", "新建成功", "success");
                  this.updateDataTag = !this.updateDataTag; // 更新
                  this.resetPageNum = false;
                }
              })
              .catch((error) => {
                utils.notificationInfo("提示", "新建失败", "warning");
                console.log(error);
              });
          } else {
            // revise

            api
              .revisePersonInfo(this.addInfoForm)
              .then((res) => {
                // console.log(res)
                this.dialogVisible = false;
                if (res.data.code == 0) {
                  utils.notificationInfo("提示", "修改成功", "success");
                  this.updateDataTag = !this.updateDataTag; // 更新
                  this.resetPageNum = false;
                }
              })
              .catch((error) => {
                utils.notificationInfo("提示", "修改失败", "warning");
                console.log(error);
              });
          }
        } else {
          //   表单验证失败
          // console.log('error submit!!');
          return false;
        }
      });
    },

    //筛选部门过滤
    filterHandler(value, row) {
      return row.department == value;
    },

    // 重置查询
    resetQuery() {
      Object.keys(this.queryForm).forEach((key) => {
        this.queryForm[key] = "";
      });
      this.updateDataTag = !this.updateDataTag;
      this.currentPage = 1; // 重置页码
    },

    //表格数据获取
    dataQueryFunc() {
      if (this.jurisdiction != "0" && this.department != "1") {
        return;
      }
      //查询条件
      let paramObj = {
        //   0 在职  1 离职
        is_departure: 1,
      };
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key] != "") {
          paramObj[key] = this.queryForm[key];
        }
      });
      return {
        apiName: "getPersonInfo",
        paramObj: paramObj,
        success: function(response, callBack) {
          // 表格组件中，调用接口后的成功回调中调用该方法
          let records = response.data.data.emp;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (
                obj[key] == null ||
                obj[key] == undefined ||
                obj[key] == "null"
              ) {
                obj[key] = "";
              }
            });

            // 时间格式处理
            let timeArr = [
              "birthday",
              "add_time",
              "departure_time", // 离职时间
              "regula", // 转正时间
              "graduation_time", // 毕业时间
              "contract_signing_date", // 合同签订日期
              "contract_expiration_date", // 合同到期日期
              "social_security_payment_time", // 社保缴纳时间
              "provident_fund_time", // 公积金缴纳时间
            ];
            timeArr.forEach((key) => {
              if (obj[key]) {
                if (obj[key].split(" ").length > 1) {
                  obj[key] = obj[key].split(" ")[0];
                }
              }
            });

            arr.push(obj);
          }
          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数
          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  position: absolute;
  width: 80px;
  height: 28px;
  opacity: 0;
  cursor: pointer;
}
.form-main {
  text-align: center;
}
.formItems {
  padding: 0 20px;
  padding-right: 40px;
  width: 30%;
  text-align: left;
}

.f-select {
  width: 195px;
}
</style>
